type VideoPlaybackRegistration = {
  id: number;
  pause: () => void;
};

let nextVideoPlaybackId = 1;
const registrations = new Map<number, VideoPlaybackRegistration>();

export function createVideoPlaybackId() {
  return nextVideoPlaybackId++;
}

export function registerActiveVideoPlayback(
  id: number,
  pause: () => void,
) {
  registrations.set(id, { id, pause });
  return () => {
    registrations.delete(id);
  };
}

export function pauseOtherActiveVideos(activeId: number) {
  const activeRegistrations = Array.from(registrations.values());
  for (const registration of activeRegistrations) {
    if (registration.id === activeId) continue;
    registration.pause();
  }
}

export function pauseAllActiveVideos() {
  const activeRegistrations = Array.from(registrations.values());
  for (const registration of activeRegistrations) {
    registration.pause();
  }
}
